'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserController = function () {
  function UserController(UsersDataProvider) {
    "ngInject";

    (0, _classCallCheck3.default)(this, UserController);
    this.UsersDataProvider = UsersDataProvider;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
    this.field = 'id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    this.getUsers();
  }

  (0, _createClass3.default)(UserController, [{
    key: 'getSortRecors',
    value: function getSortRecors(field, order_type, col, colTopDown) {
      this.field = field;
      this.order_type = order_type;
      this.col = col;
      this.colTopDown = colTopDown;
      this.getUsers();
    }
  }, {
    key: 'getUsers',
    value: function getUsers() {
      var vm = this;
      var data = {};
      var searchData = {};
      searchData.id = vm.id;
      searchData.name = vm.name;
      searchData.email = vm.email;
      searchData.orgnumber = vm.orgnumber;
      searchData.company = vm.company;
      searchData.location = vm.location;
      searchData.mobile = vm.mobile;
      data.searchData = searchData;
      data.currentPage = vm.currentPage;
      data.pageLimit = vm.pageLimit;
      data.field = vm.field;
      data.order_type = vm.order_type;
      vm.UsersDataProvider.getUsers(data, searchData).then(function (result) {
        vm.users = result.data;
        vm.usersTotal = result.total;
        vm.selectall = false;
      });
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      this.id = '';
      this.name = '';
      this.email = '';
      this.orgnumber = '';
      this.company = '';
      this.location = '';
      this.mobile = '';
      this.getUsers();
    }
  }]);
  return UserController;
}();

// WEBPACK FOOTER //


exports.default = UserController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/users/components/listing/controller.js
 **/